export default __webpack_public_path__ + "static/media/practice_set.ccf8fc5d.png";